import { css as l } from "@microsoft/fast-element";
import { display as n, PropertyStyleSheetBehavior as s } from "@matrix42/fast-foundation";
import { typography as e } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
import { normalize as c } from "../common/normalize.js";
function a(r, i) {
  return new s("color", r, i);
}
function t(r, i) {
  return l`
    .control {
      /* Style */
      border-color: ${o.color[r][60]};
    }

    .dialog-header ${i.prefix}-icon {
      /* Style */
      color: ${o.color[r][100]};
    }
  `;
}
const $ = (r) => l`
    ${c}
    ${n("block")}
    .overlay {
      /* Base */
      touch-action: none;
      /* Layout */
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      /* Style */
      background: ${o.color.overlay};
    }

    .positioning-region {
      /* Layout */
      display: flex;
      justify-content: center;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      overflow: auto;
    }

    .control {
      /* Base */
      border-width: ${o.borderWidth.xs};
      border-style: solid;
      /* Layout */
      display: flex;
      flex-direction: column;
      position: relative;
      z-index: 1;
      margin-top: auto;
      margin-bottom: auto;
      padding: ${o.spacing[8]};
      /* Style */
      color: ${o.color.neutral[400]};
      box-shadow: ${o.shadow.box.xl};
      background-color: ${o.color.neutral[30]};
      border-radius: ${o.borderRadius.sm};
    }

    .dismiss-dialog {
      /* Layout */
      position: absolute;
      top: ${o.spacing[2]};
      right: ${o.spacing[2]};
    }

    .dialog-header {
      /* Layout */
      display: flex;
      align-items: center;
      gap: ${o.spacing[2]};
      margin-bottom: ${o.spacing[3]};
    }

    .dialog-header slot {
      /* Typography */
      ${e("h4", "semibold")}
    }

    .dialog-body {
      /* Layout */
      overflow: auto;
      /* Workaround to allow for outline effects and positioning the scroll bar */
      margin: 0 calc(-1 * ${o.spacing[4]});
      padding: ${o.spacing[2]} ${o.spacing[4]};
    }

    .dialog-body slot {
      /* Typography */
      ${e("p", "regular")}
    }

    .dialog-footer {
      /* Layout */
      display: flex;
      justify-content: right;
      gap: ${o.spacing[2]};
      margin: 0 calc(-1 * ${o.spacing[8]})
        calc(-1 * ${o.spacing[8]})
        calc(-1 * ${o.spacing[8]});
      padding: ${o.spacing[4]} ${o.spacing[8]}
        ${o.spacing[8]} ${o.spacing[8]};
    }

    .overflow-border {
      /* Style */
      border-top: ${o.borderWidth.xs} solid
        ${o.color.neutral[60]};
    }
  `.withBehaviors(
  a("primary", t("primary", r)),
  a("error", t("error", r)),
  a("success", t("success", r))
);
export {
  $ as dialogStyles
};
